import React from 'react';
import DocumentReader from './DocumentReader';
import { documentTitle, documentSlug, rules } from './content/modelRules';

export default function ModelRules() {
  return (
    <DocumentReader
      documentId={documentSlug}
      title={documentTitle}
      intro="NASAA model rules have no legal force on their own — they only apply once a state adopts them. These are the rules named in NASAA's official Series 65 exam outline, most heavily tested rules reproduced in full, the rest as accurate structured summaries."
      parts={[{ id: 'model-rules-full', title: null, sections: rules }]}
    />
  );
}
